var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Box, MenuItem } from '@mui/material';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getCPFFormatado } from '../../../utils';
import { getUsuarios, getUsuariosPerfis, STATUS_API } from '../../../api';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
import InputDados from '../../../components/input_dados';
var COLUNAS = [
    {
        field: 'nome',
        headerName: 'Nome',
        width: 400,
    },
    {
        field: 'email',
        headerName: 'Email',
        width: 300,
    },
    {
        field: 'cpf',
        headerName: 'CPF',
        width: 150,
        valueGetter: function (value) { return getCPFFormatado(value); },
    },
    {
        field: 'situacao',
        headerName: 'Situação',
        width: 150,
    },
];
var Usuarios = function () {
    var _a = useState([]), perfisOptions = _a[0], setPerfisOptions = _a[1];
    // Carrega os perfis para preencher o select de filtros
    useEffect(function () {
        getUsuariosPerfis().then(function (resposta) {
            if ((resposta === null || resposta === void 0 ? void 0 : resposta.Status) === STATUS_API.ERRO) {
                alert(resposta.Mensagem);
            }
            else if (resposta) {
                setPerfisOptions(resposta || []);
            }
        });
    }, []);
    return (_jsx(GridBase, { pagina: PAGINAS.USUARIOS, paginaPermissao: FUNCIONALIDADES.USUARIOS, rota: ROUTES.USUARIOS, columns: COLUNAS, filtrosIniciais: {
            situacao: '-1',
            perfil: '-1',
        }, fetchData: function (textoBusca, filtros, paginationModel) {
            return getUsuarios(textoBusca, filtros.situacao === '-1' ? null : filtros.situacao, filtros.perfil === '-1' ? null : filtros.perfil, paginationModel);
        }, renderFiltros: function (filtros, atualizarFiltros) {
            var _a;
            return (_jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', gap: 2, width: '100%' } }, { children: [_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                            atualizarFiltros({ situacao: novaSituacao });
                        } }), _jsx(Box, __assign({ sx: { width: 300 } }, { children: _jsxs(InputDados, __assign({ select: true, id: 'perfil', label: 'Perfil', placeholder: 'Perfil', value: (_a = filtros.perfil) !== null && _a !== void 0 ? _a : '-1', onChange: function (e) {
                                atualizarFiltros({ perfil: e.target.value });
                            }, size: 'small', fullWidth: true }, { children: [_jsx(MenuItem, __assign({ value: '-1' }, { children: "Selecione..." })), perfisOptions.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) }))] })));
        } }));
};
export default Usuarios;
